import { Injectable } from '@angular/core';
import { AuthorizationService } from '@infodata-group/inf-commons';

@Injectable({
  providedIn: 'root',
})
export class CustomAuthorizationService extends AuthorizationService {
  override initLogin(id: string) {
    super.initLogin(id);
  }
}
